export const refineDateString = (dateString: string): boolean => {
  const [day, month, year] = dateString.split('.');
  const normalized = `${year}-${month}-${day}`;
  const date = new Date(normalized);
  return !isNaN(date.getTime());
};
